"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StyledRadioCardWrapper = exports.StyledRadioCardGroup = void 0;
const theme_1 = require("@pulse-web-ui/theme");
require("./radio-card-group.types");
exports.StyledRadioCardGroup = theme_1.styled.div `
  ${({ isCurrency, isBasicVersion, desktopGap = 24 }) => isBasicVersion
    ? (0, theme_1.css) `
          display: flex;
          flex-wrap: wrap;
          gap: 16px;
        `
    : (0, theme_1.css) `
          ${theme_1.mixins.flex({
        wrap: true,
        gap: isCurrency ? 8 : 16,
    })}
          ${theme_1.media.desktop} {
            gap: ${isCurrency ? '8' : desktopGap}px;
          }
        `}

  ${({ horizontalAlign }) => horizontalAlign &&
    (0, theme_1.css) `
      justify-content: ${horizontalAlign};
    `}
`;
exports.StyledRadioCardWrapper = theme_1.styled.div `
  ${theme_1.mixins.flex({})}
  align-content: stretch;
  ${({ desktopWidth, isCurrency }) => isCurrency
    ? (0, theme_1.css) `
          width: auto;
          min-width: ${desktopWidth ? `${desktopWidth}px` : 'calc(50% - 12px)'};
        `
    : `
        width: 100%;
        `}

  ${theme_1.media.desktop} {
    ${({ desktopWidth, isCurrency }) => isCurrency
    ? (0, theme_1.css) `
            width: auto;
            min-width: ${desktopWidth
        ? `${desktopWidth}px`
        : 'calc(50% - 12px)'};
          `
    : `
        width: ${desktopWidth ? `${desktopWidth}px` : 'calc(50% - 12px)'};
        `}
  }

  ${({ isBasicVersion }) => isBasicVersion &&
    (0, theme_1.css) `
      width: auto;

      ${theme_1.media.desktop} {
        width: auto;
      }
    `}
`;
